import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { HelmetProvider } from "react-helmet-async";
import { ScrollProgressBar } from "@/components";
import { setDynamicCanonical } from "./setCanonical.ts";

setDynamicCanonical();


createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
    <ScrollProgressBar />
      <App />
    </HelmetProvider>
  </StrictMode>
);
